// extracted by mini-css-extract-plugin
export default {"header":"styles_header__TU8lK","actions":"styles_actions__rU6wP"};